import { Navigate, Outlet } from 'react-router-dom';
import { storage } from '../Shared/Utils/authStorage';

interface ProtectedRouteProps {
  allowedRoles: string[];
  allowedPrivileges?: string[];
  requireAllPrivileges?: boolean;
}

const ProtectedRoute = ({
  allowedRoles,
  allowedPrivileges,
  requireAllPrivileges = false,
}: ProtectedRouteProps) => {
  const token = storage.getToken();
  const userRole = storage.getRole();
  const isAuthenticated = !!token;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole ?? "")) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (allowedPrivileges && allowedPrivileges.length > 0 && userRole !== 'SUPER_ADMIN') {
    const hasPrivileges = requireAllPrivileges
      ? storage.hasAllPrivileges(...allowedPrivileges)
      : storage.hasPrivilege(...allowedPrivileges);
    if (!hasPrivileges) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
